module.exports = __webpack_public_path__ + "web/img/login-bg.44c5876c.png";